import React from 'react';

interface Props {
  mediaType: string;
  model: any;
}

const tryRequire = (inPath, inDefaults) => {
  let res;
  try {
    res = require(`./medias/${inPath}`);
  } catch (e) {
    res = require(`./medias/${inDefaults}`);
  }
  return res.default;
};

export const MediaComponent = (props: Props) => {
  const { mediaType, model } = props;
  const Media = tryRequire(mediaType.toLowerCase(), 'unknown');
  return <Media model={model} />;
};
